import { render, staticRenderFns } from "./adminAndTeacher.vue?vue&type=template&id=5ba9d924&scoped=true"
import script from "./adminAndTeacher.vue?vue&type=script&lang=js"
export * from "./adminAndTeacher.vue?vue&type=script&lang=js"
import style0 from "./adminAndTeacher.vue?vue&type=style&index=0&id=5ba9d924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba9d924",
  null
  
)

export default component.exports